<style lang="scss" scoped>
    .share-modal {
        .btn-social {
            border-radius: 50%;
            padding: 12px 10px !important;
            margin-right: auto;
            margin-bottom: auto;
        }

        .facebook {
            background: #3b5998;
            border-color: #3b5998;
            color: #fff;
        }

        .twitter {
            background: #76A9EA;
            border-color: #76A9EA;
            color: #fff;
        }

        .google {
            background: #dd4b39;
            border-color: #dd4b39;
            color: #fff;
        }

        .tumblr {
            background: #32506d;
            border-color: #32506d;
            color: #fff;
        }

        .pinterest {
            background: #cb2027;
            border-color: #cb2027;
            color: #fff;
        }

		.email{
			background: #76A9EA;
            border-color: #76A9EA;
            color: #fff;
		}
		.instagram{
			background: transparent linear-gradient(180deg, #C74F4C 0%, #C3246B 52%, #7A22B9 100%) 0% 0% no-repeat padding-box;
			color:#fff;
		}

		.actions{
			padding-top: 15px;
			padding-bottom: 15px;
		}

		.row-buttons{
            margin-left: -24px !important;
            margin-right: -24px !important;
			margin-top: 20px;
            .btn {
                padding: 15px 40px !important;
            }
        }
		.image-media-content{
            width: 100%;
            border-radius: 5px;
        }

		.details{
			margin-left : 40px;
		}
    }

	@media screen and (max-width: 768px) {
        .share-modal{
			.details{
				margin-left: 0;
			}
        }
    }

    @media screen and (max-width: 543px) {
        .share-modal{
			.share-buttons{
				margin-left: 0px;
				margin-right: 0px;
				text-align : center;
				margin-top : 20px;
				.btn-social {
					margin-right: 0px;
				}
			}

			.btn-close{
				width: 100%;
			}
        }
    }
	.modal{
		&-title {
			&--centered{
				padding: 0px;
				text-align: center;
			}

		}
	}
	.media-container{
		display:flex;
		align-items:center;
	}

	.copy-button{
		position: absolute;
		z-index:1;
		width: 50px;
		margin-left: -50px;
		border:none;
		height:50px;
		border-radius: 0px 5px 5px 0px;

	}
	.input-url{
		width:100%;
		height:50px;
		padding-right:50px;
		padding-left:10px;
	}
	.media-container{
		display:flex;
		align-content:space-between;
	}
	.btn-social{
		margin-left: auto !important;
		margin-right: auto !important;
	}
	.parent-container{
		padding-top: 40px;
		padding-bottom: 40px;
		border-radius: 5px;
		&__background{
			margin: 0 -12px;
			padding: 0 12px;
			@media only screen and (max-width: 991px) and (min-width:768px) {
				margin: 0 -8px;
				padding: 0 8px;
			}
			@media only screen and (max-width: 767px) {
				margin: 0 -4px;
				padding: 0 4px;
			}
		}
		@media only screen and (max-width: 767px) {
				padding-top: 15px;
		}
	}
	.tabs-container{
		margin-bottom:40px;
	}
	.tabs-wrapper{
		position: relative;
		overflow: hidden;
		height:244px;
	}
	.tabs-element{
		font-size: 16px;
		font-weight: 500;
		border-bottom: 5px solid red;
	}
	.share-beat-tab{
		:hover{
			opacity:0.8;
		}
	}
	.share-playlist-tab{
		:hover{
			opacity:0.8;
		}
	}

	@media only screen and (max-width: 768px) {
	.share-modal{
		.row-buttons {
			margin-left: -8px !important;
			margin-right: -8px !important;
		}
	}
	.parent-container {
		padding-left: 40px !important;
		padding-right: 40px !important;
	}
	.tabs-wrapper{
		height:248px;
	}
	}
	@media only screen and (max-width: 991px) and (min-width:767px) {
		.share-modal {
			.row-buttons {
				margin-left: -16px !important;
				margin-right: -16px !important;
			}
		}
	}
	@media only screen and (max-width:1158px) and (min-width:1017px){
		.modal{
			font-size: 12px;
		}
	}
	@media only screen and (max-width:1017px) and (min-width:992px){
		.modal{
			font-size: 11px;
		}
	}
	@media only screen and (max-width:776px) and (min-width:767px){
		.modal{
			font-size: 10.5px;
		}
	}
	@media only screen and (max-width:623px) and (min-width:544px){
		.modal{
			font-size: 11px;
		}
	}
	.modal-title{
		margin-top: 1rem;
	}

</style>

<template>
	<div class="share-modal modal fade" id="shareModal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn" @click="closeModal">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div v-if="loadModal" class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12"  v-if="shareable">
									<!--
									<div class="col-xs-12 col-sm-4 col-md-4">
										<img class="image-media-content" :src="shareable.image(300)">
									</div>
									-->
                                    <div class="row actions">
										<div class= "row">
											<div class="col-xs-12 col-sm-12 col-md-8 offset-md-2">
												<div class="col-xs-4 offset-xs-4 col-sm-4 offset-sm-4 col-md-4 offset-md-4">
													<img class="image-media-content" :src="shareable.image(300)">
												</div>
											</div>

										</div>
										<div class="row">
											<h4 class="modal-title modal-title--centered" :style="$highlightColor">SHARE {{ shareable.name }}</h4>
											<p class="modal-subtitle text-center">{{ descriptionMsg }}</p>
										</div>
										<!-- parent-container -->
										<div class="parent-container__background" :style="$modalBackgroundStyleOpaque">
										<div class ="row parent-container" :style="{'height':'420px', 'background-color':$highlightColor.color.concat('10')}">
										<div class="col-md-10 offset-md-1" >
											<!-- tabs container -->
											<div class="row tabs-container">
												<div class="col-xs-12 col-sm-12 col-md-12">
													<div class="col-xs-6 col-sm-6 col-md-6 tabs-element share-beat-tab" @click="this.shareBeatClickHandler" style="cursor: pointer;" :style="activeTab(this.tabs.beat.active, $highlightColor.color)">
														<p class="text-center" :style="highlightColor(this.tabs.beat.active)">Share <br v-if=" window.width < 444 "> Beat Page</p>
													</div>
													<div class="col-xs-6 col-sm-6 col-md-6 tabs-element share-playlist-tab" @click="this.sharePlaylistClickHandler" style="cursor: pointer;" :style="activeTab(this.tabs.playlist.active, $highlightColor.color)">
														<p class="text-center" :style="highlightColor(this.tabs.playlist.active)">Highlight<br v-if=" window.width < 444 "> In Playlist</p>
													</div>
												</div>
											</div>
											<!-- end tabs container -->

											<div class="row position-relative tabs-wrapper" id="myTabContent">
												<transition
												name="view"
												:enter-class="tabs.beat.active ? 'view-enter':'view-enter-reverse'"
												:leave-to-class="tabs.beat.active ? 'view-leave-to':'view-leave-to-reverse'"
												>
												<!-- tab 1 -->
												<div class="col-xs-12 col-sm-12 col-md-12 share-beat"  key="1" v-if="this.tabs.beat.active" >
													<div class="row" >
														<!-- media container -->
														<div class="media-container form-group share-buttons col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
															<template v-for="method in methods">
																<a class="btn-social btn btn-lg" :class="method.class" :href="parseUrl(method.url)" target="_blank" @click="sendGaEvent(method.name)">
																<font-awesome-icon :icon="[method.icon.prefix, method.icon.name]" fixed-width></font-awesome-icon>
																</a>&nbsp;
															</template>
														</div>
														<!-- end of media container -->
														<!-- the input component -->
														<div class="form-group col-xs-12 col-sm-12 col-md-12">
															<label class="form-label">Short Url</label>
															<template v-if="shortUrlLoading">
																<p class="text-center"><font-awesome-icon icon="spinner-third" spin></font-awesome-icon></p>
															</template>
															<template v-if="!shortUrlLoading && shortUrl">
																<input type="text" id="beatShortUrl" name="shortUrl" class="input-url" v-model="shortUrl" onclick="this.select();">
																<button name="copyShortUrl" :style="$mainButtonStyle" class="copy-button" id="copy-button-1" @click="copyTestingCode($event, 'beatShortUrl')" data-original-title title>
																	<font-awesome-icon icon="copy" fixed-width size="lg"></font-awesome-icon>
																</button>
															</template>
														</div>
														<!-- end of the input component -->
														<div class="form-group col-xs-12 col-sm-12 col-md-12">
																<label class="form-label">Share Url</label>
																<input type="text" id="beatFullUrl" ref="input" name="fullUrl" class="input-url" v-model="shareUrl" onclick="this.select();">
																<button name="copyShortUrl" :style="$mainButtonStyle" class="copy-button" id="copy-button-2" @click="copyTestingCode($event, 'beatFullUrl')" data-original-title title>
																	<font-awesome-icon icon="copy" fixed-width size="lg"></font-awesome-icon>
																</button>
														</div>
													</div>
												</div>
												<!-- tab 2 -->
												<div class="col-xs-12 col-sm-12 col-md-12 share-page" key="2" v-if ="!this.tabs.beat.active">
													<div class="row" >
														<!-- media container -->
														<div class="media-container form-group share-buttons col-xs-12 col-sm-8 offset-sm-2 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
															<template v-for="method in methods">
																<a class="btn-social btn btn-lg" :class="method.class" :href="parseUrlPlaylist(method.url)" target="_blank" @click="sendGaEvent(method.name)">
																<font-awesome-icon :icon="[method.icon.prefix, method.icon.name]" fixed-width></font-awesome-icon>
																</a>&nbsp;
															</template>
														</div>
														<!-- end of media container -->
														<!-- the input component -->
														<div class="form-group col-xs-12 col-sm-12 col-md-12">
															<label class="form-label">Short Url</label>
															<template v-if="shortUrlLoading">
																<p class="text-center"><font-awesome-icon icon="spinner-third" spin></font-awesome-icon></p>
															</template>
															<template v-if="!shortUrlLoading && shortUrl">
																<input type="text" id="playlistShortUrl" name="shortUrl" class="input-url" v-model="shortUrlPlaylist" onclick="this.select();">
																<button name="copyShortUrl" :style="$mainButtonStyle" class="copy-button" id="copy-button-3" @click="copyTestingCode($event, 'playlistShortUrl')" data-original-title title>
																	<font-awesome-icon icon="copy" fixed-width size="lg"></font-awesome-icon>
																</button>
															</template>
														</div>
														<!-- end of the input component -->
														<div class="form-group col-xs-12 col-sm-12 col-md-12">
																<label class="form-label">Share Url</label>
																<input type="text" id="playlistFullUrl" name="fullUrl" class="input-url" v-model="sharePlaylist" onclick="this.select();">
																<button name="copyShortUrl" :style="$mainButtonStyle" class="copy-button" id="copy-button-4" @click="copyTestingCode($event, 'playlistFullUrl')" data-original-title title>
																	<font-awesome-icon icon="copy" fixed-width size="lg"></font-awesome-icon>
																</button>
														</div>
													</div>
												</div>
												<!-- end of tab 2 -->
												</transition>
											</div>

										</div>
										</div>
										</div>
										<!-- end of the parent container -->
									</div>
									<!-- the button close -->
									<div class="row row-buttons">
											<button :style="$mainButtonStyle" type="button" class="btn btn-close btn-block" data-dismiss="modal">Close</button>
									</div>

								</div>
                            </div>
                        </div>
                    </div>
                </div>
				<div v-if="!loadModal" class="row">
					<div class="col-md-8 offset-md-2">
					<div class="row">
						<div class="row item-list item-list-sm item-list-by m-b">
						<div class="col-xs-12" v-if="shareable">
							<h4 class="modal-title" :style="$highlightColor">
							SHARE {{ shareable.name }}
							</h4>
							<p>{{ descriptionMsg }}</p>
							<div class="row actions">
							<div class="col-xs-12 col-sm-4 col-md-4">
								<img class="image-media-content" :src="shareable.image(300)" />
							</div>
							<div class="col-xs-12 col-sm-8 col-md-8">
								<div class="row details">
								<div
									class="form-group share-buttons col-xs-12 col-sm-12 col-md-12"
								>
									<template v-for="method in methods">
									<a
										class="btn-social btn btn-lg"
										:class="method.class"
										:href="parseUrl(method.url)"
										target="_blank"
										@click="sendGaEvent(method.name)"
									>
										<font-awesome-icon
										:icon="[method.icon.prefix, method.icon.name]"
										fixed-width
										></font-awesome-icon> </a>&nbsp;
									</template>
								</div>
								<div class="form-group col-xs-12 col-sm-12 col-md-12">
									<label class="form-label" :style="$mainPrimaryTextStyle">Short Url</label>
									<template v-if="shortUrlLoading">
									<p class="text-center">
										<font-awesome-icon
										icon="spinner-third"
										spin
										></font-awesome-icon>
									</p>
									</template>
									<template v-if="!shortUrlLoading && shortUrl">
									<input
										type="text"
										name="shortUrl"
										class="form-control"
										v-model="shortUrl"
										onclick="this.select();"
									/>
									</template>
								</div>
								<div class="form-group col-xs-12 col-sm-12 col-md-12">
									<label class="form-label" :style="$mainPrimaryTextStyle">Share Url</label>
									<input
									type="text"
									name="fullUrl"
									class="form-control"
									v-model="shareUrl"
									onclick="this.select();"
									/>
								</div>
								</div>
							</div>
							</div>
							<div class="row text-right row-buttons">
							<div class="form-group col-xs-12 col-sm-12 col-md-12">
								<button
								:style="$mainButtonStyle"
								type="button"
								class="btn btn-close"
								data-dismiss="modal"
								>
								Close
								</button>
							</div>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
            </div>
        </div>
	</div>
</template>
<style>

	.view-enter-active {
		transition: opacity 0.2s ease-in-out, transform 0.2s ease;
	}
	.view-leave-active {
		transition: opacity 0.2s ease-in-out, transform 0.2s ease;
	}
	.view-enter-active {
		transition-delay: 0.2s;
	}
	/* The reverse is for the data we are loading */
	.view-enter {
		opacity: 0;
		transform: translateX(200px);
	}
	.view-enter-reverse{
		opacity: 0;
		transform: translateX(-200px);
	}
	/* ------------------------------------------ */
	.view-enter-to {
		opacity: 1;
		transform: translateX(0px);
	}
	.view-leave {
		opacity: 1;
		transform: translateX(0px);
	}
	/* The reverse is for the data we are loading */
	.view-leave-to {
		opacity: 0;
		transform: translateX(-200px);
	}
	.view-leave-to-reverse {
		opacity: 0;
		transform: translateX(200px);
	}


</style>
<script>

	import Configure from "../../mixins/configure";

	export default {
		mixins:[Configure],
		props: ['shareable','shareFromPage'],
        mounted() {
		    this.$store.commit("shareModal", {modal: $(this.$el)})
        },
		data() {
			return {
				newModal: {
					load: false,
					page: null
				},
				window:{
					width:null,
					height:null
				},
			    shortUrlLoading: false,
				shortUrl: null,
				shortUrlPlaylist: null,
			    baseUrl: ab.baseUrl,
				methods: [
					{
						name: 'Facebook',
						class: 'facebook',
						icon: {
						    prefix: 'fab',
						    name: 'facebook-f'
                        },
						url: `https://www.facebook.com/dialog/feed?app_id=${ab.facebookAppId}&display=popup&redirect_uri={redirect_uri}&link={url}&picture={image}&is_video=true&description={message}`,
					},
					{
						name: 'Twitter',
						class: 'twitter',
						icon: {
						    prefix: 'fab',
						    name: 'twitter'
                        },
						url: 'https://twitter.com/share?text={message}&url={url}',
					},
					{
						name: 'Email',
						class: 'email',
						icon: {
						    prefix: 'far',
                            name: 'envelope'
                        },
						url: 'mailto:?subject={message}&body={url}',
					},
				],
				tabs: {
					beat:{
						active: true
					},
					playlist: {
						active: false
					}
				}

			}
		},
        computed: {
		    descriptionMsg() {
		        if (this.shareable.getType() === 'service') {
		            return 'Let your friends and followers know how you can serve them.'
                } else {
		            return 'Let your friends and followers know what you\'re listening to.'
                }
            },
			loadModal(){
				let load = null;
				if (this.shareFromPage != null) {

					if (this.shareFromPage.type === "beats")
						{
							load=true;
						}

					else{
						load=false;
					}
					return load;
				}

				return load;
			},
		    user() {
		        return this.$store.state.user
            },
            config() {
                return this.$store.state.currentConfig
            },
            shareUrl() {

                let url = this.shareable.shareUrl()

                // add config id if not default
                if (this.config && this.config.id && !this.config.default) {
                    url += `&config=${this.config.id}`;
                }
                return url;
            },
			sharePlaylist(){
				if(this.shareFromPage !=null){
					return this.baseUrl.concat(this.shareFromPage.link,'?','beat_id=',this.shareable.id.toString());
				}
				return null;
			}
		},

		created() {
			window.addEventListener('resize', this.windowSize);
			this.windowSize();
		},
    	destroyed() {
        	window.removeEventListener('resize', this.windowSize);
		},
		methods: {
			closeModal(){
				this.tabs.beat.active = true;
				this.tabs.playlist.active = false;
			},
			windowSize(){
			this.window.width = window.innerWidth;
			},
			setTooltip(target, message) {
				$("#" + target).tooltip('hide')
					.attr('data-original-title', message)
					.tooltip('show');
			},
			hideTooltip(target) {
				setTimeout(function() {
					$("#" + target).tooltip('hide').attr('data-original-title', '');
				}, 1000);
			},
			copyTestingCode (event, id) {
				let testingCodeToCopy = document.querySelector('#'+id)
				testingCodeToCopy.select()
				let targetId = event.currentTarget.id;

				try {
					var successful = document.execCommand('copy');
					this.setTooltip(targetId, 'Copied!');
  					this.hideTooltip(targetId);
				} catch (err) {
					this.setTooltip(targetId, 'Failed!');
  					this.hideTooltip(targetId);
				}
			},
			loadNewModal(){
				if(this.shareFromPage !== null)
					return this.shareFromPage.type !== 'charts' && this.shareFromPage.type !== 'beats';
				return null;
			},
			highlightColor(value){
				if(value){
					return {'font-weight':'bold', 'color':this.$highlightColor.color};
				}

				return {};
			},
			select() {
      			this.$refs.input.select();
    		},
			parseUrl(url) {
				let image = (this.shareable.artwork && this.shareable.artwork.files[300] != undefined) ? this.shareable.artwork.files[300] : this.user.avatar.files[300];

				return url.replace('{url}', encodeURI(this.shortUrl))
						.replace('{message}', `${this.shareable.name} by ${this.user.name}`)
						.replace('{redirect_uri}', encodeURI(`${ab.siteUrl}/facebook/share/callback`))
						.replace('{image}', encodeURI(image));
			},
			parseUrlPlaylist(url) {
				let image = (this.shareable.artwork && this.shareable.artwork.files[300] != undefined) ? this.shareable.artwork.files[300] : this.user.avatar.files[300];

				return url.replace('{url}', encodeURI(this.shortUrlPlaylist))
						.replace('{message}', `${this.shareable.name} by ${this.user.name}`)
						.replace('{redirect_uri}', encodeURI(`${ab.siteUrl}/facebook/share/callback`))
						.replace('{image}', encodeURI(image));
			},
			sendGaEvent(socialMedia) {
                this.$store.state.eventTracker.socialShare(this.shareable, socialMedia);
			},

			capitalizeWord(str) {
				return str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
					return letter.toUpperCase();
				});
			},
			shareBeatClickHandler(){

				$('.view-enter').css({'transform':'translateX(200px)'});
				$('.view-leave-to').css({'transform':'translateX(-200px)'});

				this.tabs.beat.active = true;
				this.tabs.playlist.active = false;

			},
			sharePlaylistClickHandler(event){

				$('.view-enter').css({'transform':'translateX(-200px)'});
				$('.view-leave-to').css({'transform':'translateX(200px)'});

				this.tabs.beat.active = false;
				this.tabs.playlist.active = true;

			},
			activeTab(flag, color){
				if(flag) return {'border-bottom': '3px solid '.concat(color) };
				else return {'border-bottom':'none'};
			},
		},
		watch: {
			shareFromPage(value){

				if(value!=null){
					let obj = JSON.parse(JSON.stringify(value));
					if(obj.type ==="beats")
						this.newModal.load=true;
					else
						this.newModal.load=false;
				}
			},
		    shareable() {
		        this.shortUrlLoading = true;

		        this.$http.get(`${ab.apiUrl}/url/short`, {
		            params: {
                        url: this.shareUrl
					}
				}).then((response) => {
                    this.shortUrl = response.data.short;
                    this.shortUrlLoading = false;
                }).catch((error) => {
                    this.shortUrlLoading = false;
                });

				if(this.sharePlaylist !=null){

					this.$http.get(`${ab.apiUrl}/url/short`, {
						params: {
							url: this.sharePlaylist
						}
					}).then((response) => {

						this.shortUrlPlaylist = response.data.short;
						this.shortUrlLoading = false;
					}).catch((error) => {
						this.shortUrlLoading = false;
					});
				}

			}
		}
	}
</script>
